export const APP_NAME = 'Kuuma: Substrate Vault';

export const COLORS = {
  // Colors from https://tailwindcss.com/docs/customizing-colors
  primary: '#4f46e5', // Indigo 600
  secondary: '#7c3aed', // Violet 600

  primaryDark: '#3730a3', // Indigo 800
  secondaryDark: '#5b21b6', // Violet 800
};

export const STORAGE_KEYS = {
  theme: 'theme',
  namespace: 'kuuma',
};

export const DRAWER_WIDTH = 240;
